import React from "react";
import { Loader2, CheckCircle2, Film, Sparkles, Youtube, AlertCircle } from "lucide-react";

export const PipelineProgressModal = ({ isOpen, step, statusMessage, error, shortData, onClose }) => {
  if (!isOpen) return null;

  const steps = [
    { id: 1, title: "1. Guion Viral (IA)", desc: "Generando hook magnético, estructura narrativa y metadatos SEO" },
    { id: 2, title: "2. Generación de Assets & Escenas", desc: "Composición de fondos y tipografía con Pillow" },
    { id: 3, title: "3. Renderizado Vertical 9:16 (FFmpeg)", desc: "Ensamblaje H.264 1080×1920 con audio ambiente armónico" },
    { id: 4, title: "4. Publicación en YouTube API", desc: "Upload resumable o guardado listo para subir" }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
      <div 
        data-testid="pipeline-progress-modal"
        className="w-full max-w-lg bg-[#12141D] border border-white/10 rounded-2xl p-6 sm:p-8 shadow-2xl relative"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-red-600/20 border border-red-500/30 flex items-center justify-center text-red-500">
            <Film className="w-5 h-5 animate-pulse" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-white">Fábrica de Shorts en Proceso</h3>
            <p className="text-xs text-slate-400">Automatizando guion, render y exportación</p>
          </div>
        </div>

        {error ? (
          <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-xl text-red-400 text-sm mb-6 flex items-start gap-3">
            <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold">Error durante el proceso:</p>
              <p className="text-xs mt-1 text-slate-300">{error}</p>
            </div>
          </div>
        ) : (
          <div className="space-y-4 mb-6">
            {steps.map((s) => {
              const isCompleted = step > s.id || (step === 3 && s.id <= 3);
              const isCurrent = step === s.id;
              return (
                <div 
                  key={s.id}
                  className={`flex items-start gap-3 p-3 rounded-xl border transition-all ${
                    isCurrent 
                      ? "bg-red-500/10 border-red-500/40 shadow-sm"
                      : isCompleted
                      ? "bg-slate-900/60 border-emerald-500/30"
                      : "bg-slate-900/20 border-white/5 opacity-40"
                  }`}
                >
                  <div className="mt-0.5">
                    {isCompleted ? (
                      <CheckCircle2 className="w-5 h-5 text-emerald-400" />
                    ) : isCurrent ? (
                      <Loader2 className="w-5 h-5 text-red-400 animate-spin" />
                    ) : (
                      <div className="w-5 h-5 rounded-full border border-slate-600 flex items-center justify-center text-[10px] text-slate-500 font-mono">
                        {s.id}
                      </div>
                    )}
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-white">{s.title}</h4>
                    <p className="text-xs text-slate-400">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="p-3 bg-black/40 border border-white/10 rounded-lg text-xs font-mono text-slate-300 flex items-center justify-between mb-6">
          <span className="truncate">{statusMessage || "Procesando pipeline..."}</span>
          <span className="text-red-400 font-bold shrink-0 ml-2">1080×1920</span>
        </div>

        {(step >= 3 || error) && (
          <button
            data-testid="pipeline-close-btn"
            type="button"
            onClick={onClose}
            className="w-full bg-slate-800 hover:bg-slate-700 text-white font-semibold py-2.5 rounded-xl border border-white/10 transition-colors"
          >
            {error ? "Cerrar" : "Ver Short Terminado"}
          </button>
        )}
      </div>
    </div>
  );
};
